//eslint-disable-next-line
export const PASS_PATTERN = /^(?=.*[A-Za-z])(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{8,}$/g;
//eslint-disable-next-line
export const LOGIN_PATTERN = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,10}$/;
//eslint-disable-next-line
export const NUMBER_LATIN_PATTERN = /^\w+$/;
